<template>
  <div>
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" ref="searchForm">
            <el-form-item label="商品编码:" prop="skuCodeList">
              <el-input v-model="searchForm.skuCodeList" clearable placeholder="请输入商品编码"></el-input>
            </el-form-item>
            <el-form-item label="商品名称:" prop="skuName">
              <el-input v-model.trim="searchForm.skuName" placeholder="请输入商品名称"></el-input>
            </el-form-item>
            <el-form-item label="是否清仓:">
              <el-select v-model="searchForm.clearance" placeholder="全部">
                <el-option label="全部" value="" />
                <el-option label="是" value="是" />
                <el-option label="否" value="否" />
                <el-option label="-" value="-" />
              </el-select>
            </el-form-item>
            <el-form-item label="标签:">
              <el-select v-model="searchForm.changeFlag" placeholder="全部">
                <el-option label="全部" value="" />
                <el-option label="新增" value="0" />
                <el-option label="变更" value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="更新人员:" prop="userName">
              <el-input v-model.trim="searchForm.userName" placeholder="请输入更新人员"></el-input>
            </el-form-item>
            <el-form-item label="销售状态:" prop="saleStatusList">
              <el-select v-model="searchForm.saleStatusList" multiple collapse-tags placeholder="请选择销售状态" @change="saleStatusCahnge">
                <el-option label="全部" value="" v-show="!all"></el-option>
                <el-option label="取消所有" value="cancleAll" v-if="all"></el-option>
                <el-option v-for="item in saleStatusList" :value="item.saleStatus" :label="item.saleStatus" :key="item.saleStatus"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="更新时间:" prop="timeRange">
              <el-date-picker
                v-model="searchForm.timeRange"
                unlink-panels
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button class="green-btn" size="mini" @click="searchPage">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="resetForm">重置</el-button>
          </template>
        </search-box>
      </template>

      <table-panel ref="tablePanel">
        <template v-slot:header-right>
          <el-button size="mini" class="green-btn" @click="salesTypeClick" v-permission="'ec-pc-new$goodsManage$priceManagement$salespriceIndex$salesState'"
            >销售状态</el-button
          >
          <el-button size="mini" class="green-btn" @click="importExcelSalesPrice">销售价导入</el-button>
          <el-button size="mini" class="green-btn" @click="importExcelActualPrice">实际执行价导入</el-button>
          <el-button size="mini" class="orange-btn" @click="terminate(null)">终止</el-button>
          <el-button type="primary" slot="reference" size="mini" @click="tableVisible = true">表格设置</el-button>
        </template>
        <el-table
          border
          ref="table"
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          @selection-change="onSelectChange"
          :height="maxTableHeight"
          v-if="tableReload"
          :data="tableData.list"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :span-method="handleSpanMethod"
          style="width: 100%"
        >
          <el-table-column fixed type="selection" :selectable="selectableMethods"></el-table-column>
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="item.width"
            :sortable="item.sortable ? 'custom' : false"
            :align="item.align"
            :fixed="item.fixed"
            show-overflow-tooltip
            v-for="item in columnData"
            :key="item.prop"
          >
            <template slot-scope="scope">
              <template v-if="item.label == '图片'">
                <el-button size="mini" type="text" v-if="scope.row.imgUrlList && scope.row.imgUrlList.length" @click="viewImg(scope.row)">查看</el-button>
              </template>
              <template v-else-if="item.label == '基础零售价'">
                <span v-if="scope.row.retailPrice">{{ scope.row.retailPrice }}</span>
                <el-link type="primary" :underline="false" v-else @click="priceDetail('retailPrice', scope.row)">明细</el-link>
              </template>
              <template v-else-if="item.label == '清仓销售价'">
                <span v-if="scope.row.clearancePrice">{{ scope.row.clearancePrice }}</span>
              </template>
              <template v-else-if="item.label == '有效期'">
                <span>{{ scope.row.validtyStart }}<span v-if="scope.row.validtyStart && scope.row.validtyEnd">至</span>{{ scope.row.validtyEnd }}</span>
              </template>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="handleAddClick(scope.row)" v-if="scope.row.isAdd == '1'">新增</el-link>
              <el-link type="primary" :underline="false" @click="handleEdit(scope.row)" v-if="scope.row.validtyStart && scope.row.validtyEnd">编辑</el-link>
              <el-link
                type="primary"
                :underline="false"
                @click="terminate(scope.row)"
                v-if="
                  scope.row.validtyStart &&
                  scope.row.validtyEnd &&
                  new Date(scope.row.validtyEnd).getTime() > new Date().getTime() &&
                  new Date(scope.row.validtyStart).getTime() < new Date().getTime()
                "
                >终止</el-link
              >
              <el-link
                type="primary"
                :underline="false"
                @click="delGoods(scope.row)"
                v-if="scope.row.validtyStart && scope.row.validtyEnd && new Date(scope.row.validtyStart).getTime() > new Date().getTime()"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onCurrentChange"
              :current-page="tableData.pageNum"
              :page-sizes="[30, 100, 500, 1000]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              background
              :total="tableData.total"
            ></el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>

    <!-- 销售状态弹窗 -->
    <sale-status-dialog
      ref="saleStatusDialog"
      :visible.sync="isShowSalesType"
      :saleStatusList="saleStatusList"
      :searchFormData="searchFormData"
      :saleStatusBeforeList="saleStatusBeforeList"
      @success="searchPage"
      @notify-open="showNotifyDialog = true"
    />
    <!-- 编辑弹窗 -->
    <salesprice-edit-dialog
      :visible.sync="dialogFormVisible"
      :row="requestParam"
      :actionType="actionType"
      :saleStatusList="saleStatusList"
      @success="onSearch"
      @close="initRequestParam"
    />

    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close
      ><imgShow :imgList="imgList"></imgShow
    ></el-dialog>
    <el-dialog title="明细" :visible.sync="detailVisible" :close-on-click-modal="false" width="50%">
      <index-detail :row="detailRow" v-if="detailVisible"></index-detail>
    </el-dialog>
    <!-- 自定义列 -->
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
    <!-- 上传通知店铺 -->
    <notify-store-dialog :visible.sync="showNotifyDialog" v-if="showNotifyDialog" @confirm="handleNotifyConfirm" />
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import { FILE_TYPE } from '@/utils/Global.js';
import imgShow from '@/views/components/imgShow';
import customProps from './customProps.mixin';
import indexDetail from './index-detail';
import notifyStoreDialog from '@/components/notify-store-dialog/notify-store-dialog';
import axios from '@/utils/axiosInstance';
import tableMixin from '@/utils/tableMixin';
import SalespriceEditDialog from './salesprice-edit-dialog.vue';
import SaleStatusDialog from './sale-status-dialog.vue';

export default {
  name: 'SalesPriceIndex',
  mixins: [customProps, pagePathMixin, tableMixin],
  components: { imgShow, indexDetail, notifyStoreDialog, SalespriceEditDialog, SaleStatusDialog },
  data() {
    const validate = (rule, value, callback) => {
      const reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2}))|0)$/;
      if (value && !reg.test(value)) {
        callback(new Error('请输入最多包含两位小数的正数!'));
      } else {
        callback();
      }
    };
    const integer = (rule, value, callback) => {
      const reg = /^\d+$/;
      if (value && !reg.test(value)) {
        callback(new Error('请输入整数!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      reportName: 'skuSalesPriceUpdateReport',
      searchForm: {
        skuCodeList: '',
        skuName: '',
        userName: '',
        timeRange: [],
        status: null,
        changeFlag: '',
        clearance: '',
        saleStatusList: [],
      },
      requestParam: {},
      searchFormData: {},
      dialogFormVisible: false,
      isShowSalesType: false,
      showNotifyDialog: false,

      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      statusOptions: [
        {
          label: '未提交',
          value: -1,
        },
        {
          label: '财务驳回',
          value: 0,
        },
        {
          label: '财务审核中',
          value: 1,
        },
        {
          label: '审核完成',
          value: 2,
        },
      ],
      saleStatusList: [],
      loading: false,
      addDialogVisible: false,
      multipleSelection: [],
      styles: [],

      imgFormVisible: false,
      imgList: [],
      actionType: '',
      detailVisible: false,
      detailRow: '',
      isTempPrice: false,
      all: false,
      tableReload: true,
      selectedData: [],
      saleStatusBeforeList: [],
    };
  },
  computed: {
    permitList() {
      return JSON.parse(localStorage.getItem('permitList'));
    },
    isAClassPrice() {
      let Jurisdiction = 'ec-pc-new$goodsManage$priceManagement$salespriceIndex$editAClassPrice';
      return this.permitList.includes(Jurisdiction);
    },
  },
  methods: {
    saleStatusCahnge(val) {
      this.all = val.length == this.saleStatusList.length + 1;
      if (val.includes('')) {
        this.searchForm.saleStatusList = this.saleStatusList.map((v) => v.saleStatus);
        this.all = true;
      } else if (val.includes('cancleAll')) {
        this.searchForm.saleStatusList = [];
        this.all = false;
      }
    },
    getSaleStatusBefore() {
      this.$refs.saleStatusDialog && this.$refs.saleStatusDialog.setLoading(true);
      const { skuCodeList } = this.searchForm;
      const param = {
        pageNum: 1,
        pageSize: 999999,
        filterData: {
          skuCodeList: skuCodeList ? skuCodeList.split(' ') : [],
        },
        exportTag: false,
      };
      this.searchFormData = param.filterData;
      this.$q.goods
        .listMngSalesPrice({
          data: param,
        })
        .then((data) => {
          if (!data) {
            return;
          }
          this.saleStatusBeforeList = this.formatTableData(data.data.records);
          this.$refs.saleStatusDialog && this.$refs.saleStatusDialog.setLoading(false);
        });
    },
    handleNotifyConfirm(data) {
      this.$refs.saleStatusDialog.handleNotifyConfirm(data);
    },
    salesTypeClick() {
      if (!this.searchForm.skuCodeList) {
        this.$message.error('请输入商品编码后在进行操作！');
        return;
      }
      this.isShowSalesType = true;
      this.getSaleStatusBefore();
    },
    // 关组件弹窗
    closed() {
      this.addDialogVisible = false;
    },
    checkStatus(row, index) {
      // 未提交和财务驳回的才能勾选
      return row.auditStatus === '未提交' || row.auditStatus === '财务驳回';
    },
    onSelectChange(val) {
      this.multipleSelection = val;
    },
    handleRemove(rowData) {
      this.$confirm('此操作将永久删除该商品销售价信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 点击确定
          this.$q.goods
            .removeGoodsSalesPrice({
              params: { priceAuditId: rowData.id },
            })
            .then((data) => {
              if (!data) {
                return;
              }
              if (data.code === '200') {
                this.$message({
                  message: '删除成功',
                  type: 'success',
                });
                this.onSearch();
              } else {
                this.$message({
                  message: data.message,
                  type: 'error',
                });
              }
            });
        })
        .catch(() => {
          // 点击取消
        });
    },
    dateFormat: function (timestamp) {
      if (!timestamp) {
        return '';
      }
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let datetime = new Date(timestamp);
      // 获取年月日时分秒值  slice(-2)过滤掉大于10日期前面的0
      let year = datetime.getFullYear(),
        month = ('0' + (datetime.getMonth() + 1)).slice(-2),
        date = ('0' + datetime.getDate()).slice(-2),
        hour = ('0' + datetime.getHours()).slice(-2),
        minute = ('0' + datetime.getMinutes()).slice(-2),
        second = ('0' + datetime.getSeconds()).slice(-2);
      // 拼接
      let result = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second;
      // 返回
      return result;
    },
    handleAddClick(rowData) {
      this.requestParam = { ...rowData };
      this.actionType = 'add';
      this.dialogFormVisible = true;
    },
    handleEdit(rowData) {
      this.requestParam = { ...rowData };
      this.actionType = 'modify';
      this.dialogFormVisible = true;
    },
    searchPage() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch() {
      this.loading = true;
      const { skuCodeList, timeRange } = this.searchForm;
      let filterData = { ...this.searchForm };
      // 处理时间范围
      if (timeRange && timeRange.length === 2) {
        filterData.startDate = timeRange[0];
        filterData.endDate = timeRange[1];
      }
      delete filterData.timeRange;
      filterData.skuCodeList = skuCodeList ? skuCodeList.split(' ') : [];

      const param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: filterData,
        exportTag: false,
      };
      this.searchFormData = param.filterData;
      this.$q.goods
        .listMngSalesPrice({
          data: param,
        })
        .then((data) => {
          if (!data) {
            return;
          }
          this.tableData = {
            ...data.data,
            list: this.formatTableData(data.data.records),
          };
          console.log(this.tableData);
          this.loading = false;
        });
    },
    initRequestParam() {
      this.requestParam = {
        goodsName: '',
      };
    },
    initSearchForm() {
      this.searchForm = {
        skuCodeList: '',
        skuName: '',
        userName: '',
        timeRange: [],
        status: null,
        changeFlag: '',
        clearance: '',
        saleStatusList: [],
      };
    },
    resetForm() {
      this.tableData.pageNum = 1;
      this.initSearchForm();
      this.onSearch();
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },

    // 销售价导入
    importExcelSalesPrice() {
      this.openSubPage({
        // 核心语句
        path: '/dataImport/goodsSalesPriceDataImport',
        query: {
          fileName: '商品销售价导入.xlsx',
          appCode: 'ec-pc-api',
          reportName: 'goodsSalesPriceDataImport',
        },
      });
    },
    // 实际执行价导入
    importExcelActualPrice() {
      this.openSubPage({
        // 核心语句
        path: '/goods/salesprice/import',
        query: {
          fileName: '商品实际执行价格导入.xlsx',
          appCode: 'ec-pc-api',
          reportName: 'goodsExecutePriceImport',
        },
      });
    },
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = row.imgUrlList;
      for (const item of list) {
        this.imgList.push(item.path);
      }
    },
    // 销售价明细dialog
    priceDetail(type, row) {
      console.log(row);
      this.detailVisible = true;
      this.detailRow = { type, ...row };
    },
    // tabldata 格式化 合并单元格
    formatTableData(data) {
      let list = [];
      data.forEach((v) => {
        if (v['goodsSaleList'].length) {
          let item = [];
          v['goodsSaleList'].forEach((k) => {
            let obj = k;
            obj['imgUrlList'] = v['imgUrlList'];
            obj['goodsCode'] = v['goodsCode'];
            obj['goodsName'] = v['goodsName'];
            item.push(obj);
          });
          list.push(...item);
        } else {
          list.push({
            imgUrlList: v['imgUrlList'],
            goodsCode: v['goodsCode'],
            goodsName: v['goodsName'],
            isAdd: '1',
          });
        }
      });
      return list;
    },
    // table 单元格合并
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      let goodsCodeArr = this.tableData.list.map((v) => v['goodsCode']);
      let arr = [];
      goodsCodeArr.forEach((item, index) => {
        if (index === 0) {
          arr.push({ goodsCode: 1 });
          return;
        }
        if (goodsCodeArr[index - 1] !== item) {
          arr.push({ goodsCode: 1 });
        } else {
          arr[arr.length - 1]['goodsCode']++;
        }
      });
      let newArr = [];
      arr.forEach((item, index) => {
        if (item.goodsCode > 1) {
          newArr.push(item);
          for (let i = 1; i < item.goodsCode; i++) {
            newArr.push({ goodsCode: null });
          }
        } else {
          newArr.push(item);
        }
      });
      if (columnIndex < 3 && columnIndex > 0) {
        if (newArr[rowIndex]['goodsCode']) {
          return {
            rowspan: newArr[rowIndex]['goodsCode'],
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },

    terminate(row) {
      let ids;
      if (row) {
        ids = [row.goodsCode];
      } else {
        ids = this.multipleSelection.map((v) => v.goodsCode);
      }
      this.$q.goods.batchUpdateValidDate({ data: ids }).then((res) => {
        if (res.code == 200) {
          this.$message.success('已终止');
        } else {
          this.$message.error(res.message);
        }
        this.onSearch();
      });
    },
    selectableMethods(row, index) {
      if (row.validtyStart && row.validtyEnd && new Date(row.validtyEnd).getTime() > new Date().getTime()) {
        return true;
      } else {
        return false;
      }
    },
    delGoods(row) {
      this.$confirm('是否要删除该商品', '提示')
        .then((_) => {
          return this.$q.goods.salesPriceRemove({
            params: {
              priceAuditId: row.id,
            },
          });
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('已删除');
          } else {
            this.$message.error(res.message);
          }
          this.onSearch();
        });
    },
    getSaleStatusList() {
      let data = {
        pageSize: 999,
        pageNum: 1,
        reportCode: 'goodsSaleStatusList',
        queryMatch: [],
        hasCount: 'Y',
      };
      axios.post(`/ec-pc-api/custom/reports/data/goodsSaleStatusList`, data).then((res) => {
        if (res.code == 200) {
          this.saleStatusList = res.data.list;
        }
      });
    },
  },
  mounted() {
    this.getSaleStatusList();
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>


.wrap_tooltip {
  display: inline-block;
  max-width: 200px; // 最大的宽度，必写属性
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  height: auto;
}

.auto-label-width
  >>> .el-form-item__label
    width 50px !important
  >>> .el-form-item__content
    margin-left 50px !important
    margin-right 90px
>>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width auto

>>> .el-select__tags-text {
  display: inline-block;
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// >>> .el-select .el-tag__close.el-icon-close {
//   top: -7px;
// }

>>> .el-table .el-table__fixed {
    height:auto !important;
    bottom:11px;
}

>>> .el-table__fixed-right {
  height:auto !important;
  bottom:11px;
}


>>> .el-table__body-wrapper {
  &::-webkit-scrollbar { // 滚动条高 解决行未对齐
    height: 11px;
  }
}
>>> .el-table__fixed-body-wrapper .el-table__body {
  padding-bottom: 11px; // 滚动条高度

}
</style>
